import * as AlertDialog from '@radix-ui/react-alert-dialog';

export const InitialWarningDialog = ({ showInitialWarning, setShowInitialWarning }) => (
    <AlertDialog.Root open={showInitialWarning} onOpenChange={(open) => { if (!open) setShowInitialWarning(false); }}>
      <AlertDialog.Portal>
        <AlertDialog.Overlay className="radix-dialog-overlay-motion fixed inset-0 bg-black/50" />
        <AlertDialog.Content className="radix-dialog-content-centered-motion fixed top-[50%] left-[50%] max-h-[85vh] w-[90vw] max-w-[500px] translate-x-[-50%] translate-y-[-50%] rounded-lg bg-white p-6 shadow-xl focus:outline-none">
          <AlertDialog.Title className="text-lg font-semibold text-gray-900 mb-4">
            ⚠️ Important: AI-Generated Content Warning
          </AlertDialog.Title>
          
          {/* Move the content out of AlertDialog.Description */}
          <div className="text-gray-600 text-xs mb-6 space-y-4">
            <AlertDialog.Description asChild>
              <p>
                This document contains AI-generated content. Please be aware that:
              </p>
            </AlertDialog.Description>
            
            <ul className="list-disc pl-3 space-y-2">
              <li>AI can make mistakes, hallucinate, or generate incorrect information</li>
              <li>All AI-generated sections are highlighted in purple for easy identification</li>
              <li>It is your professional responsibility to thoroughly review and verify all content</li>
              <li>Any errors in the final document are your responsibility</li>
            </ul>
            
            <p className="font-semibold mt-4">
              By proceeding, you acknowledge that you understand your responsibility to verify all AI-generated content.
            </p>
          </div>
          
          <div className="flex justify-end">
            <AlertDialog.Action asChild>
              <button
                onClick={() => setShowInitialWarning(false)}
                className="px-4 py-2 text-sm font-bold bg-violet-900 text-white rounded-lg hover:bg-violet-800 focus:outline-none focus:ring-2 focus:ring-violet-500 focus:ring-offset-2"
              >
                I Understand and Accept
              </button>
            </AlertDialog.Action>
          </div>
        </AlertDialog.Content>
      </AlertDialog.Portal>
    </AlertDialog.Root>
  );